<template>
  <div>
    <!-------------------heading------------->
    <v-row class="d-flex justify-space-between" flat>
      <v-col cols="12" md="6">
        <h1 class="heading-1">Hardship Application</h1>
      </v-col>
    </v-row>

    <!--------- search and filter-------------->
    <v-row class="mt-6">
      <v-col cols="12" md="4" sm="6">
        <v-card flat style="color: #f2f3f9">
          <v-text-field
            dense
            outlined
            prepend-inner-icon="mdi-magnify"
            label="Search"
            v-model="search"
            @input="searchData()"
            single-line
          >
          </v-text-field>
        </v-card>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <v-card
          height="45"
          outlined
          class="px-2 mt-n1 d-flex justify-start align-center"
          style="cursor: pointer"
          @click="filterDialog = true"
        >
          <div
            class="d-flex justify-space-between align-center"
            style="width: 100%"
          >
            <div>
              <v-icon>mdi-tune</v-icon>
              <span
                class="mx-1"
                style="letter-spacing: 1px; color: rgba(0, 0, 0, 0.87)"
                >Filters</span
              >
            </div>

            <div>
              <v-icon>mdi-menu-down</v-icon>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="filterDialog" max-width="430" persistent>
      <v-card class="py-5">
        <v-card-title class="mb-5 d-flex justify-space-between align-center">
          <div class="text-h5"><b>Filters</b></div>
          <div>
            <v-btn text depressed class="pa-0" @click="cleanFilter()">
              <span class="primary--text" style="letter-spacing: 0px"
                >Clean filters</span
              >
            </v-btn>
            <v-icon class="ml-3" @click="filterDialog = false"
              >mdi-close</v-icon
            >
          </div>
        </v-card-title>

        <v-card-text>
          <v-select
            class="my-5"
            outlined
            v-model="filterMembership"
            :items="filterMembershipList"
            item-text="name"
            item-value="id"
            dense
            hide-details
            label="By Membership"
            persistent-hint
            :menu-props="{ maxHeight: '400' }"
          ></v-select>

          <v-menu
                ref="datarangemenu"
                v-model="datarangemenu"
                :close-on-content-click="false"
                :return-value.sync="Renewaldates"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="Renewaldates"
                    append-icon="mdi-calendar"
                    readonly
                    class="my-5"
                    dense
                    label="Date"
                    hide-details
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dates" no-title scrollable range>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="datarangemenu = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.datarangemenu.save(Renewaldates)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>

          <!---------------------Type-modalitiy model filter-------------------------------->
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#646464"
            outlined
            depressed
            class="px-5"
            text
            @click="filterDialog = false"
          >
            <span class="" style="#646464"> Cancel </span>
          </v-btn>
          <v-btn
            color="primary"
            class="px-8 ml-2"
            @click="sendFilters()"
            depressed
          >
            <span class="textt_style"> Save Filters </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card class="mt-6" outlined>
      <v-data-table
        :headers="headers"
        :loading="tableLoader"
        loading-text="Loading... Please wait"
        :search="search"
        :items="getAllHardshipApplications.Data"
        :page.sync="page"
        :items-per-page="displayedItemsPerPage"
        @page-count="pageCount = $event"
        hide-default-footer
      >
        <template v-slot:[`item.index`]="{ index }">
          <span class="index_index_text">
            {{ index + displayedItemsPerPage * (page - 1) + 1 }}</span
          >
        </template>
        <template v-slot:[`item.CreatedDate`]="{ item }">
          <span class="index_index_text"> {{ item.CreatedDate.split("T")[0] }} </span>
        </template>
        <template v-slot:[`item.MembershipLevel`]="{ item }">
          <!-- <span class="index_head_text"> {{ item.MembershipLevel == 0 ? "Standard" : "Practitioner" }} Member</span> -->
          <span class="index_head_text"> {{ getMembershipLabel(item.MembershipLevel) }}</span>
        </template>
        <template v-slot:[`item.Status`]="{ item }">
          <span class="index_index_text"> {{ item.Status == 1? "Approved":item.Status == 2 ? "Deny" : "Pending" }} </span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu transition="scroll-y-transition" offset-y color="transparent">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="#A1A1A6" v-bind="attrs" v-on="on">
                mdi-dots-horizontal
              </v-icon>
            </template>
            <v-card flat>
              <v-list class="px-3 pt-1" color="transparent">
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="openSeeApplicationDialog(item)"
                  >
                  <!-- :disabled="isButtonDisabled(item)" -->
                  <v-icon color="#646464">mdi-eye</v-icon>
                  <span
                    class="ml-4 text_stylee action_dialog"
                    >See Application</span
                  >
                </v-btn>
              </v-list>

              <v-list class="px-3 pt-1" color="transparent">
                <v-btn
                  depressed
                  color="transparent"
                  block
                  class="d-flex justify-start"
                  @click="deleteHardship(item)"
                >
                  <v-icon color="#646464">mdi-delete</v-icon>
                  <span class="ml-4 text_stylee action_dialog">Remove</span>
                </v-btn>
              </v-list>
            </v-card>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
    <v-card flat class="my-9 d-flex justify-end align-center">
      <span class="text_transform pa-0 ma-0">Per page : </span>
      <v-card flat width="100" class="mx-5">
        <v-select
          :items="ItemsPerPageItems"
          label="Items per page"
          v-model="itemsPerPage"
          @input="handleItemPerPage()"
        ></v-select>
      </v-card>
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="5"
        @input="fetchHardshipData"
      ></v-pagination
    ></v-card>
    <!--------------------------- Add SEE Application Dialog-------------------------->
    <v-dialog
      v-model="Seeappliactiondialog"
      @click:outside="closeDialog"
      persistent
      max-width="600"
    >
      <v-card v-if="Seeappliactiondialog">
        <div class="d-flex justify-end px-7 pt-7">
          <v-icon @click="Seeappliactiondialog = false">mdi-close </v-icon>
        </div>
        <div>
          <Seeappliaction @close="close" :hardshipData="hardshipData" :userData="userData"></Seeappliaction>
        </div>
        <div class="pl-12 pr-12 pb-3">
          <span class="h1_tab2">Set Status</span>
          <v-card flat>
            <v-select
              v-model="selectedStatus"
              class="pt-1"
              :items="setStatusArray"
              :readonly="isReadOnly"
              menu-props="auto"
              dense
              single-line
              outlined
              hide-details=""
              return-object
              bg-color="red"
            ></v-select>
          </v-card>
        </div>
        <div class="pl-12 pr-12 pb-3" v-if="seeApplicationStatus === 3 || seeApplicationStatus === 1">
          <span class="h1_tab2">Set Coupon Amount</span>
          <div class="pb-3">
            <v-card flat>
              <v-select
                v-model="selectedCoupon"
                class="pt-1"
                :items="setCouponArray"
                :disabled="selectedStatus !== 'Approve'"
                menu-props="auto"
                dense
                single-line
                outlined
                hide-details=""
                return-object
                :readonly="readOnlySelectedCoupon !== null"
              ></v-select>
            </v-card>
          </div>
          <span class="block" v-if="selectedStatus === 'Approve'">
            <b>Note,</b> the User will be sent a one-time-use, auto-generated
            coupon code in their confirmation email that will be valid for 90
            days.
          </span>
        </div>
        <div class="pa-12 d-flex justify-content-end gap-3 pt-0"
        v-if="this.seeApplicationStatus === 3">
          <div class="pl-6">
            <v-btn
              class="px-13 py-5"
              depressed
              color="#737373"
              @click="Seeappliactiondialog = false"
              :disabled="selectedStatus === 'Approve' && !selectedCoupon"
              ><span style="color: white">CANCEL</span>
            </v-btn>
          </div>
          <div>
            <v-btn
              class="px-13 py-5"
              depressed
              color="primary"
              @click="handleApprovalSubmission"
              :disabled="selectedStatus === 'Approve' && !selectedCoupon"
              >SUBMIT
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <!--------------------------- Approw Dialog-------------------------->

    <v-dialog v-model="approveDialog" persistent max-width="380">
      <v-card v-if="approveDialog">
        <div class="d-flex justify-end pa-5 pb-0">
          <v-icon @click="approveDialog = false">mdi-close </v-icon>
        </div>
        <v-card-title class="d-flex justify-center text-h5"
          >{{ selectedStatus === "Approve"?"Approval": "Denial"}}  Confirmed
        </v-card-title>
        <v-card-text
          class="d-flex justify-center index_span_2_style px-5"
          style="text-align: center"
          >This User will receive an email {{ selectedStatus === "Approve"?"confirmation": "Denial"}} with next
          steps.</v-card-text
        >
        <div class="d-flex justify-center index_span_2_style px-5">
          Add a personal message (optional)
        </div>
        <div class="px-5 mt-6">
          <v-textarea outlined></v-textarea>
        </div>
        <v-card-actions
          class="d-flex justify-center index_span_2_style px-5 pb-8"
        >
          <v-btn
            depressed
            color="primary"
            class="px-6 py-5"
            @click="send()"
          >
            Send {{ selectedStatus === "Approve"?"Approval": "Denial"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--------------------------- Deney Dialog-------------------------->
    <v-dialog v-model="deneyDialog" persistent max-width="380">
      <v-card>
        <div class="d-flex justify-end pa-5 pb-0">
          <v-icon @click="deneyDialog = false">mdi-close </v-icon>
        </div>
        <v-card-title class="d-flex justify-center text-h5"
          >Denial Confirmed
        </v-card-title>
        <v-card-text
          class="d-flex justify-center index_span_2_style px-5"
          style="text-align: center"
          >This User will receive a denial email with next steps.</v-card-text
        >
        <div class="d-flex justify-center index_span_2_style px-5">
          Add a personal message (optional)
        </div>
        <div class="px-5 mt-6">
          <v-textarea outlined></v-textarea>
        </div>
        <v-card-actions
          class="d-flex justify-center index_span_2_style px-5 pb-8"
        >
          <v-btn
            depressed
            color="primary "
            class="px-6 py-5"
            @click="deneyDialog = false"
          >
            Send Denial
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--------------------------- Delete Dialog-------------------------->
    <v-dialog v-model="Dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="text-h5"> Warning </v-card-title>
        <v-card-text class="index_span_2_style" style="height: 100px; font-size:22px;"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="Dialog = false">
            Cancel
          </v-btn>
          <v-btn color="red darken-1" text @click="DdialogClose()">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--------------------------- End Delete Dialog-------------------------->
  </div>
</template>

<script>
import Seeappliaction from "../../components/Hradshipapplication/seeapplication.vue";
import { mapGetters } from "vuex";
// import moment from "moment";
export default {
  components: {
    Seeappliaction,
  },
  data() {
    return {
      readOnlySelectedCoupon:null,
      filterMembership: null,
      filterModality: [],
      approveDialog: false,
      deneyDialog: false,
      filterDialog: false,
      organizeDialog: false,
      newcategorydialog: false,
      stockhistorydialog: false,
      addstockdialog: false,
      Seeappliactiondialog: false,
      seeApplicationStatus:null,
      datarangemenu: false,
      hardshipData:null,
      userData:null,
      updateinvetory: false,
      Dialog: false,
      tableLoader: false,
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      Permission: {},
      isPlaying: false,
      ispin: true,
      search: "",
      filter: "",
      filterItem: [],
      headers: [
        { text: "#", value: "index" },
        { text: "Name", value: "UserName" },
        { text: "Country", value: "Country" },
        { text: "Application Date ", value: "CreatedDate" },
        { text: "Membership Level", value: "MembershipLevel" },        
        { text: "Status", value: "Status" },        
        { text: "Member Id", value: "UserId" },
        { text: "", value: "actions", sortable: false },
      ],
      DataTableOne: [],
      filterMembershipList: [{name:"Standard",id:0}, {name:"Practitioner",id:1}],
      setStatusArray: ["Approve", "Deny"],
      setCouponArray: ["32% discount", "50% discount", "65% discount"],
      
      selectedStatus: "",
      selectedCoupon: "",
      filtersArray: [],
      dates:[]
    };
  },
  watch: {
    selectedStatus(newVal) {
      console.log("selected Status: ", newVal);
    },
    selectedCoupon(newVal) {
      console.log("selected Coupon: ", newVal);
    },
  },
  mounted() {
    // this.tableLoader = true;
    // setTimeout(() => {
    //   (this.DataTableOne = [
    //     {
    //       index: 1,
    //       name: "Chirstina Auerbach",
    //       country: "USA",
    //       date: "Jan 10, 2022",
    //       membership: "Practing Membership",
    //       memberid: "23142344",
    //     },
    //     {
    //       index: 2,
    //       name: "Chirstina Auerbach",
    //       country: "USA",
    //       date: "Jan 10, 2022",
    //       membership: "Practing Membership",
    //       memberid: "23142344",
    //       isPlaying: false,
    //       ispin: false,
    //     },
    //     {
    //       index: 3,
    //       name: "Chirstina Auerbach",
    //       country: "USA",
    //       date: "Jan 10, 2022",
    //       membership: "Practing Membership",
    //       memberid: "23142344",
    //     },
    //     {
    //       index: 4,
    //       name: "Chirstina Auerbach",
    //       country: "USA",
    //       date: "Jan 10, 2022",
    //       membership: "Practing Membership",
    //       memberid: "23142344",
    //     },
    //     {
    //       index: 5,
    //       name: "Chirstina Auerbach",
    //       country: "USA",
    //       date: "Jan 10, 2022",
    //       membership: "Practing Membership",
    //       memberid: "23142344",
    //     },
    //     {
    //       index: 6,
    //       name: "Chirstina Auerbach",
    //       country: "USA",
    //       date: "Jan 10, 2022",
    //       membership: "Practing Membership",
    //       memberid: "23142344",
    //     },
    //     {
    //       index: 7,
    //       name: "Chirstina Auerbach",
    //       country: "USA",
    //       date: "Jan 10, 2022",
    //       membership: "Practing Membership",
    //       memberid: "23142344",
    //     },
    //     {
    //       index: 8,
    //       name: "Chirstina Auerbach",
    //       country: "USA",
    //       date: "Jan 10, 2022",
    //       membership: "Practing Membership",
    //       memberid: "23142344",
    //     },
    //   ]),
    //     (this.tableLoader = false);
    // }, 1500);
    this.fetchHardshipData()
  },
  computed: {
    ...mapGetters(["GetCountry","getAllHardshipApplications","GetPreviewUser"]),
    // dateRangeText() {
    //   let firstDate = this.Renewaldates[0];
    //   let lastDate = this.Renewaldates[1];
    //   let formatDate =
    //     moment(firstDate).format("L") + "-" + moment(lastDate).format("L");
    //   return formatDate;
    // },
    getMembershipLabel() {
    return (membershipLevel) => {
      switch (membershipLevel) {
          case 1:
            return "Starter";
          case 2:
            return "Access";
          case 3:
            return "Standard";
          case 4:
            return "Practitioner";
          case 5:
            return "Instructor";
          case 6:
            return "LifeSciences";
          case 7:
            return "Deceased";
          case 8:
            return "InActive";
          case 9:
            return "Trainee Instructor";
          case 10:
            return "Senior Instructor";
          default:
            return "";
        }
    };
  },
    Renewaldates() {
      return this.dates.join(" to ");
    },
    displayedItemsPerPage() {
      return this.itemsPerPage === "All"
        ? this.getAllHardshipApplications.Data.length
        : this.itemsPerPage;
    },
    isReadOnly(){
      return this.seeApplicationStatus === 1 || this.seeApplicationStatus === 2 
    },
  },
  methods: {
    
    handleItemPerPage() {
      if (this.page !== 1) {
        this.page = 1;
      }
      this.fetchHardshipData();
    },
    searchData(){
      this.page = 1;
      this.fetchHardshipData()
    },
    fetchHardshipData(){
      this.filterDialog = false
      this.tableLoader = true;
      const obj={
        page:this.page,
        pagesize: this.itemsPerPage,
        search:this.search,
        filter:JSON.stringify(this.filtersArray) ?? []
      }
      this.$store.dispatch("GetAllHardshipApplications",obj).then((res)=>{
        console.log(res)
        this.tableLoader = false;
        if (this.itemsPerPage != "All") {
          this.pageCount = Math.ceil(res.Data.TotalRecords / this.itemsPerPage);
        } else {
          this.pageCount = 1;
        }
      })
    },
    sendFilters() {
      this.filtersArray = [];
      if (this.filterMembership || this.filterMembership == 0) {
        this.filtersArray.push({
          Key: "membership",
          Value: this.filterMembership,
        });
      }
      if (this.dates.length>0) {
        this.filtersArray.push({
          Key: "date",
          Value: this.dates.join(","),
        });
      }
      this.fetchHardshipData();
    },
    send(){
      const obj = {
        HardshipApplicationId:this.hardshipId,
        Status: this.selectedStatus == "Approve" ? 1 : 2,
        DiscountPercentage: this.selectedStatus == "Approve" ? Number(this.selectedCoupon.substr(0,2)) : 0
      }
      this.$store.dispatch("SetHardshipApplicationsStatus",obj).then(()=>{

        this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: this.selectedStatus == "Approve"?"Approve Successfully":"Denial Successfully",
          showConfirmButton: false,
          timer: 1500,
        });
        this.approveDialog = false
        this.Seeappliactiondialog = false
        this.selectedStatus = ""
        this.selectedCoupon = ""
        this.fetchHardshipData()
      })
    },
    close() {
      this.Seeappliactiondialog = false;
    },
    isButtonDisabled(item) {
    return item.Status === 1;
  },
    openSeeApplicationDialog(item){
      this.seeApplicationStatus = item.Status
      this.selectedStatus = item.Status == 1 ? "Approve" : item.Status == 2 ? "Deny" : ""
      this.selectedCoupon = item.Status == 1 ? `${item.Percentage}% discount` : null
      this.readOnlySelectedCoupon =  this.selectedCoupon
      this.hardshipId = item.Id
      this.hardshipData = item
      this.$store
      .dispatch("GetPreviewUser", item.UserId).then(()=>{
        this.userData = this.GetPreviewUser 
            this.Seeappliactiondialog = true;
          })
    },
    closeDialog() {
      this.value = false;
    },
    handleApprovalSubmission() {
      // if (this.selectedStatus === "Approve") {
        this.approveDialog = true;
      // } 
      // else if (this.selectedStatus === "Deny") {
      //   this.deneyDialog = true;
      // }
    },
    deleteHardship(item){
      this.hardshipId = item
      this.Dialog = true
      
    },
    DdialogClose() {
      this.Dialog = false;
      this.$store.dispatch("DeleteHardshipApplication",this.hardshipId.Id).then(()=>{
        this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Delete Successfully",
            showConfirmButton: false,
            timer: 1500,
          });
        this.fetchHardshipData()
      })
    },
    cleanFilter() {
      this.filterMembership = null;
      this.dates = []
    },
  },
};
</script>
<style scoped>
.h1_tab2 {
  font-family: "DM Sans";
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
  display: block;
  margin-bottom: 10px;
}
.text_style {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.25px;

  color: rgba(34, 34, 34, 0.87);
}
.index-head {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;

  color: #222222;
}
.index_span_2_style {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 18px;

  /* Color/General/Black High Emphasis */

  color: #070707;
}
.index_head_text {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;

  /* Color/General/Black High Emphasis */

  color: #222222;
}
.v-text-field__details {
  padding-top: 0px;
  margin-bottom: 0px;
}
.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
/*  */
.text_style-main {
  text-transform: none;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #0071bd;
}
.text_stylee {
  text-transform: none;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.25px;

  color: rgba(34, 34, 34, 0.87);
}
</style>
